// extracted by mini-css-extract-plugin
module.exports = {"container":"simpleCollectionTitles-module__container__3xuEj","arrow-up":"simpleCollectionTitles-module__arrow-up__KHihl"};